import { $, on, getDataAttr } from "@olmokit/dom";
import { breakpoints, gridGutter } from "@olmokit/core/scss";
import {
  glide,
  Anchors,
  Breakpoints,
  ConstrainToImgHeight,
  Controls,
  LazyLoad,
  Swipe,
} from "@olmokit/core/glide";
// import lightbox from "@olmokit/core/lightbox/base";
import { Lightbox } from "components/Lightbox";
import "./index.scss";

/**
 * Component: Gallery
 */
export default function gallery(rootSelector) {

    console.log('Gallery mounted');

    const scopedSelector = `${rootSelector ? rootSelector + " " : ""}.Gallery:`;
    const $gallery = $(scopedSelector);

    if (!$gallery) {
      return;
    }

    const gallerySlider = glide(scopedSelector, {
      sizeByTrack: true,
      gap: gridGutter,
      perView: 3,
      breakpoints: {
        [breakpoints.xl + gridGutter * 2]: {
          perView: 3,
          peek: gridGutter * 2,
        },
        [breakpoints.lg]: {
          perView: 2,
          gap: gridGutter,
          peek: { before: gridGutter, after: gridGutter * 2 },
        },
        [breakpoints.md]: {
          perView: 2,
          gap: gridGutter / 2,
          peek: { before: gridGutter / 4, after: gridGutter * 1.5 },
        },
        [breakpoints.sm]: {
          perView: 1,
          gap: gridGutter / 2,
          peek: { before: gridGutter / 4, after: gridGutter },
        },
        440: {
          perView: 1,
          gap: gridGutter / 2,
          peek: gridGutter / 4,
        },
      },
    }).mount({
      Swipe,
      Anchors,
      Breakpoints,
      Controls,
      ConstrainToImgHeight,
      LazyLoad,
    });

    Lightbox();

}
